import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { localConfig } from '../../../Configs/localConfig'
import { api } from '../../api'

type Pontos = {
  NOME: number
  INDICE: number
  COMENTARIO: string
  LATITUDE: number
  LONGITUDE: number
}

type Analises = {
  title: string
  cod_analises: {
    cod: number
    valor: number
  }
  id: string
  pontos: Pontos[]
  valor_analise: number
}

interface PropsPostOs {
  data: string
  status: number
  cod_laboratorio: number
  cod_representante?: number
  cod_propriedade: number
  cod_talhao?: number
  cod_tipo: number
  arquivo_kml?: any
  cod_responsaveis: number[]
  solicitante: string
  cod_area_amostra: number
  cod_safra_conta: number
  malha_de_pontos: {}
  /** `null` quando não informada — `limparCamposVazios` remove a chave do body. */
  data_liberada: string | null
  data_coleta: string | null
  analises: Analises[]
  valor: number
  refetch: () => void
}

const limparCamposVazios = (obj: Record<string, any>): Record<string, any> => {
  // @ts-ignore
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, valor]) => valor !== null && valor !== undefined && valor !== '' && valor !== 'Invalid Date'
    )
  )
}

export const usePostOsParaColeta = (): {
  carregando_salvar_os: boolean
  mutate_os: (params: PropsPostOs) => void
  isSuccess_os: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostOs> = useMutation(
    async (params: PropsPostOs) => {
      const { refetch, ...dados } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      const body = limparCamposVazios(dados)

      return api
        .post(
          `/pedido-laboratorio?codConta=${localConfig()?.conta}&codSafra=${
            localConfig()?.codSafra
          }&codCliente=${localConfig()?.codCliente}`,
          body
        )
        .then((response: any) => {
          successAlert('Os cadastrada com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar os!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao salvar os!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_os: mutation.isLoading,
    mutate_os: mutation.mutate,
    isSuccess_os: mutation.isSuccess,
  }
}

export const usePutOsParaColeta = (cod: number): {
  carregando_editar_os: boolean
  mutate_editar_os: (params: PropsPostOs) => void
  isSuccess_editar_os: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostOs> = useMutation(
    async (params: PropsPostOs) => {
      const { refetch, ...dados } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      const body = limparCamposVazios(dados)

      return api
        .post(
          `/pedido-laboratorio/${cod}?codConta=${localConfig()?.conta}&codSafra=${
            localConfig()?.codSafra
          }&codCliente=${localConfig()?.codCliente}`,
          body
        )
        .then((response: any) => {
          successAlert('Os editada com sucesso!', 5000, 'loading')
          refetch?.()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao editar os!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao editar os!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_editar_os: mutation.isLoading,
    mutate_editar_os: mutation.mutate,
    isSuccess_editar_os: mutation.isSuccess,
  }
}
